define('shared/initializer/form/adapters/mixins/AjaxResultValidatable',[
    '$',
    'shared/lib/RSVP'
], 
function (
    $,
    RSVP
) {
    'use strict';

    var KEY_SUCCESS = 'Success';

    function Ctor() { }

    Ctor.prototype.doSubmit = function( data ) {
        return new RSVP.Promise(function( resolve, reject ) {

            if ( data == null || data[KEY_SUCCESS] !== true ) {
                var err = new Error(
                    'Data submitted to server was rejected, ' + 
                    'please try again'
                );
                err.fatal = false;
                reject(err);
            }
            else {
                resolve(data);
            }
            
        });
        
    };

    return Ctor;
});
